import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import axios from "axios";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import "./ListCoupon.css"

const ListCoupon = () => {
  const [userData, setUserData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const getData = async () => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/superadmin/coupons`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data); // Log response data for debugging
      // Trim the status field
      const cleanedData = response.data.map(coupon => ({
        ...coupon,
        status: coupon.status.trim()
      }));
      setUserData(Array.isArray(cleanedData) ? cleanedData : []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  

  const handleEdit = (e, id) => {
    history.push(`/edit-coupons/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://brand.aasmo.in/api/superadmin/coupons/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        getData();
      }
    } catch (error) {
      console.error("Error deleting coupon:", error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedUserId(id);
    setShowModal(true);
  };

  const handleStatusChange = async (id, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    try {
      await axios.put(`https://brand.aasmo.in/api/superadmin/coupons/${id}`, { status: newStatus }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });
      getData(); // Refresh the list after update
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>List Coupons</h2>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{ textAlign: "center", whiteSpace: "nowrap" }}>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Coupon Code</th>
                <th>Limit of User</th>
                <th>Discount Type</th>
                <th>Discount Amount</th>
                <th>Minimum Purchase</th>
                <th>Status</th>
                <th>Start Date</th>
                <th>Expire Date</th>
                <th>Date Created</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody style={{ textAlign: "center" }}>
              {userData.map((coupon, index) => (
                <tr key={coupon.id}>
                  <td>{index + 1}</td>
                  <td>{coupon.title}</td>
                  <td>{coupon.code}</td>
                  <td>{coupon.user_limit}</td>
                  <td>{coupon.discount_type}</td>
                  <td>{coupon.discount_amount}</td>
                  <td>{coupon.minimum_purchase}</td>
                  <td>
                    <label className="switch">
                      <input 
                        type="checkbox" 
                        checked={coupon.status === 'active'} 
                        onChange={() => handleStatusChange(coupon.id, coupon.status)} 
                      />
                      <span className="slider round"></span>
                    </label>
                  </td>
                  <td>{formatDate(coupon.start_date)}</td>
                  <td>{formatDate(coupon.expiry_date)}</td>
                  <td>{formatDate(coupon.created_at)}</td>
                  <td>
                    <i className="icon-pencil" onClick={(e) => handleEdit(e, coupon.id)}></i>
                    &nbsp;&nbsp;
                    <i className="fa fa-trash-o" onClick={() => handleDeleteClick(coupon.id)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ConfirmDeleteModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleConfirm={() => handleDelete(selectedUserId)}
        />
      </div>
    </div>
  );
};

export default ListCoupon;
